
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import searchGetActions from '../../sagas/search';
import { getSearchParams } from '../../reducers/search';

const classNames = mergeStyleSets({
    root: {
        width: 300
    },
    attributes: {
        paddingRight: 8,
        paddingBottom: 8,
        minHeight: 0,
        overflowY: 'auto',
        //border: '1px solid #dddddd',
        borderLeft: '0px'
    },
    buttons: {
        paddingTop: 8
    }
});

const FilterBase = (props) => {

    const dispatch = useDispatch();
    const searchActions = searchGetActions(dispatch);
    const searchParams = useSelector(state => getSearchParams(state.search, props.objectType));

    const handleItemChange = (id, value) => {
        searchActions.setSearchParam(props.objectType, id, value);
        if (props.onChangeItem) {
            props.onChangeItem(id, value);
        }
    }

    return (
        <Stack verticalFill className={classNames.root}>
            <Stack.Item grow className={classNames.attributes}>
                {(props.items || []).map(item => {
                    return React.cloneElement(
                        item,
                        {
                            key: item.props.definition.id,
                            value: searchParams[item.props.definition.id],
                            onChange: handleItemChange
                        }
                    );
                })}
            </Stack.Item>
        </Stack>
    );
}

export default FilterBase;
